<template>
  <nav>
    <v-app-bar fixed app>
      <router-link style="display: inline-flex; text-decoration: none;" to="/">
        <img id="logo" src="../assets/logo1_sm.png" alt="Logo">
        <v-toolbar-title class="grey--text">
          <span>PAZDERNIK</span>
          <span class="font-weight-light">.NET</span>
        </v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn text v-for="item in items" :key="item.title" :to="item.to">
          <v-icon class="mr-2 grey--text title">mdi-{{ item.icon }}</v-icon>
          <span>{{ item.title }}</span>
        </v-btn>
      </v-toolbar-items>

      <v-menu v-model="menu">
        <template v-slot:activator="{ on }">
          <v-app-bar-nav-icon class="hidden-md-and-up mr-1" v-on="on"></v-app-bar-nav-icon>
        </template>
        <v-list>
          <v-list-item v-for="item in items" :key="item.title" :to="item.to">
            <v-icon class="mr-3 grey--text subtitle-1">mdi-{{ item.icon }}</v-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </nav>
</template>

<script>
  export default {
    name: "MainMenu",
    data () {
      return {
        menu: false,
        items: [
          {
            title: 'Úvod',
            icon: 'home',
            name: 'Home',
            to: '/o-mne'
          },
          {
            title: 'Zkušenosti',
            icon: 'arrange-send-backward',
            name: 'Skills',
            to: '/zkusenosti'
          },
          {
            title: 'Reference',
            icon: 'book-open-page-variant',
            name: 'References',
            to: '/reference'
          },
          {
            title: 'Životopis',
            icon: 'clipboard-list',
            name: 'Cv',
            to: '/zivotopis'
          },
          {
            title: 'Kontakt',
            icon: 'email',
            name: 'Contact',
            to: '/kontakt'
          },
        ]
      }
    }
  }
</script>

<style scoped>
  #logo {
    margin-right: .5rem;
    height: 1.8rem;
    width: 1.8rem;
  }
</style>